import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ConfettiComponent } from './confetti.component';
import { TaxPlanningService } from '../../../tpiq-services/tax-planning.service';
import { SignupService } from '../../../tpiq-services/signup.service';
import { SwitchBoard } from '../../../services/SwitchBoard';
import { ToastService } from '../../../services/Toast.service';
import { TOAST_TYPE } from '../../../constants/Tpiq.constants';
import { Session } from '../../../services/Session';


@Component({
  selector: 'app-success-screen',
  standalone: true,
  imports: [CommonModule, ConfettiComponent],
  templateUrl: './success-screen.component.html',
  styleUrl: './success-screen.component.scss',
})
export class SuccessScreenComponent implements OnInit {
  private org    = Session.getOrg();
  private userId = Session.getUser().id;

  constructor(
    private router: Router,
    private taxPlanningService: TaxPlanningService,
    private signupService: SignupService,
    private switchBoard: SwitchBoard,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.taxPlanningService.clearSubscriptionData();
    const userObj: any = Session.get('user');
    userObj.onboardingStatus = 'Done';
    Session.put('user', userObj);

    // Persist onboarding completion to the backend so the wizard doesn't re-appear on next login
    this.signupService.updateCompanyOnboarding(this.org, this.userId, 'Done')
      .subscribe({ error: () => {} });

    setTimeout(() => {
      this.switchBoard.onLogin.next(Session.getUser('delegatedFrom'));
      setTimeout(() => this.router.navigate(['tpiq/dashboard']));
    }, 3000);

    // Update subscription access info in background (non-blocking)
    this.taxPlanningService.getSubscriptionStatus(this.org, this.userId).subscribe({
      next: (response) => {
        let obj: any = {
          clientPortalAccess: false,
          dashboardAccess: false,
          subscriptionStatus: response.subscriptionStatus,
          // The header logo reads productAccess (same field as login.component.ts).
          productAccess: response.productAccess,
        };
        if (response.accessList && response.accessList.length > 0) {
          obj.dashboardAccess = response.accessList.indexOf('Dashboard') !== -1;
          obj.clientPortalAccess = response.accessList.indexOf('Client Portal') !== -1;
        }
        Session.setUserAccessInfo(obj);
        this.switchBoard.onUserOnboard.next({});
      },
      error: () => { this.toastService.pop(TOAST_TYPE.error, 'Failed to get subscription status'); },
    });
  }
}
